import { useDebounce } from 'use-debounce';
import { SEARCH_DEBOUNCE_MS } from '@/constants/debounce';

/**
 * Returns a debounced version of the search value for use in API filters.
 * The immediate value should still be used for the input and URL sync.
 */
export function useDebouncedSearch(
  value: string | undefined | null,
  delayMs: number = SEARCH_DEBOUNCE_MS,
): string {
  const [debouncedValue] = useDebounce(value ?? '', delayMs);
  return debouncedValue;
}
